/**
 * Created by Tiger on 21/03/2022.
 */

export const en = {
    auth_tip: 'Authorize Google to control Qingping+ devices',
    auth_tip2: 'By authorizing, Google will control of your devices in Qingping+.',
    google_privacy: 'Review Google\'s ',
    google_privacy2: 'Privacy Policy',
    an_end: '. ',
    confirm_auth: 'Authorize ',
    read_privacy: 'Agree to ',

    login_tip: 'By signing in, you are authorizing Google to control your devices.',
    login_tip2: 'If your account has not added a mobile number or email address, please authorize in Qingping+ app.',
    input_password_tip: 'Enter the password of %@.',
    code_sent_tip: 'Verification code has been sent to %@, enter it within 10 minutes.',
    code_send_tip2: 'Didn\'t get it? Check your spam folder.',
    set_code_fail: 'Send failed',
    send_code_timeout: 'Resend in %@s',
    re_send_code: 'Resend code',
    login_fail: 'Log In Failed',
    title_input_pwd: 'Enter Password',
    select_home: 'Select Country/Region',
    country_code_placeholder: 'Search for country or region',

};
